var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading || !_vm.isEmptyObject(_vm.companyResult))?_c('div',{staticClass:"flex flex-shrink-0 items-center",class:{
    'is-dark-transparent': _vm.imageIsDark && _vm.imageContainsTransparency,
  }},[(_vm.companyLogo)?_c('img',{staticClass:"flex-1",attrs:{"src":_vm.companyLogo,"alt":_vm.imageResult && _vm.imageResult.name}}):(_vm.companyResult)?_c('img',{attrs:{"src":_vm.fallbackImage,"alt":"Office icon"}}):_c('SkeletonLine')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }